<template>
    <div class="translations-page">
        <div class="page-header">
            <h1>{{ $t('menu.translations.page.header') }}</h1>
            <p class="page-subtitle">{{ $t('menu.translations.page.subtitle') }}</p>
        </div>

        <div class="hub-grid">
            <div class="tap-hub-card" @click="$router.push({ name: 'translations-collections' })" style="animation-delay: 0.05s;">
                <div class="hub-icon">
                    <i class="bx bx-collection"></i>
                </div>
                <div class="hub-title">{{ $t('menu.translations.subpages.collections.header') }}</div>
                <div class="hub-desc">{{ $t('menu.translations.subpages.collections.collectionsDesc') }}</div>
                <div class="hub-arrow"><i class="bx bx-right-arrow-alt"></i></div>
            </div>

            <div class="tap-hub-card" @click="$router.push({ name: 'translations-blog-posts' })" style="animation-delay: 0.1s;">
                <div class="hub-icon" style="background: rgba(237, 106, 90, 0.1); border-color: rgba(237, 106, 90, 0.15);">
                    <i class="bx bx-news" style="color: #ED6A5A;"></i>
                </div>
                <div class="hub-title">{{ $t('menu.translations.subpages.blogPosts.header') }}</div>
                <div class="hub-desc">{{ $t('menu.translations.subpages.blogPosts.blogPostsDesc') }}</div>
                <div class="hub-arrow"><i class="bx bx-right-arrow-alt"></i></div>
            </div>
        </div>
    </div>
</template>

<script>
import { useSettings } from '@/store/user'
import mixins from '@/components/mixins';

export default {
    mixins: [mixins],
    setup() {
        const user = useSettings();
        return { user }
    },
    methods: {

    }
}
</script>

<style scoped>
.translations-page {
}

.page-header {
    margin-bottom: 2rem;
}
.page-subtitle {
    color: #9aa0a8;
    font-size: 0.875rem;
    margin-top: 0.125rem;
}

.hub-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 1rem;
}
.hub-grid .tap-hub-card {
    animation: slideUp 0.5s ease-out both;
}

@keyframes slideUp {
    from { opacity: 0; transform: translateY(12px); }
    to { opacity: 1; transform: translateY(0); }
}
</style>
